export default {
    manage_temperature: "Temperature",
    manage_temperatures_label: "Vehicle",
    manage_temperatures_zone_label: "Zone",
    manage_temperatures_zone_name: "Name",
    manage_temperatures_zone_high: "High (°F)",
    manage_temperatures_zone_low: "Low (°F)",
    manage_temperatures_search_by_vehicle: "Search by Vehicle"
}